<template>
  <div>
<!--    <vx-card v-can="'view-staff'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"-->
<!--             class="user-list-filters mb-8" :collapse-action="true">-->
<!--      <div class="vx-row">-->
<!--        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">-->
<!--          <label class="text-sm opacity-100 text-bold">ITS Product Code</label>-->

<!--          <vs-input type="search" placeholder="Search.." v-model="filters['site_name']" class="mb-4 md:mb-0 w-full"/>-->
<!--        </div>-->
<!--        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">-->
<!--          <label class="text-sm opacity-100 text-bold">ITS Product Name</label>-->

<!--          <vs-input type="search" placeholder="Search.." v-model="filters['address_line1']"-->
<!--                    class="mb-4 md:mb-0 w-full"/>-->
<!--        </div>-->
<!--        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">-->
<!--          <label class="text-sm opacity-100 text-bold">Supplier Product Code</label>-->

<!--          <vs-input type="search" placeholder="Search.." v-model="filters['site_telephone']"-->
<!--                    class="mb-4 md:mb-0 w-full"/>-->
<!--        </div>-->
<!--        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">-->
<!--          <label class="text-sm opacity-100 text-bold">Supplier Product Name</label>-->

<!--          <vs-input type="search" placeholder="Search.." v-model="filters['site_telephone']"-->
<!--                    class="mb-4 md:mb-0 w-full"/>-->
<!--        </div>-->

<!--      </div>-->
<!--      <div class="vx-row mt-5">-->
<!--        <div class="vx-col w-full ml-auto">-->
<!--          <vs-button class="float-right mr-4" size="small"-->
<!--                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}">CLEAR-->
<!--          </vs-button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </vx-card>-->
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="RAW MATERIALS" v-can:any="['create-raw-material', 'view-raw-material']">
          <template slot="actions">
            <vs-button v-can="'create-raw-material'" @click="onClickCreateRm" class="mr-0" color="primary"
                       type="filled">Create
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full"/>
            <vs-table v-can="'view-raw-material'" :data="raw_material_list" @sort="handleSort" stripe
                      class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th sort-key="company_product_code">ITS Product Code</vs-th>
                <vs-th sort-key="name">ITS Product Name</vs-th>
                <vs-th sort-key="name">Supplier Product Code</vs-th>
                <vs-th sort-key="name">Supplier Product Name</vs-th>
                <vs-th sort-key="name">Manufacturing Sites</vs-th>
                <vs-th sort-key="name">Country of Processing</vs-th>
                <vs-th sort-key="name">STATUS</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickViewManufacturing(data[indextr].id)" :key="indextr"
                       v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].company_product_code">
                    {{ data[indextr].company_product_code ?
                    data[indextr].category.prefix + '-' + data[indextr].company_product_code : '-' }}
                  </vs-td>
                  <vs-td :data="data[indextr].company_product_name">
                    {{ data[indextr].company_product_name ?data[indextr].company_product_name : '-' }}
                  </vs-td>
                  <vs-td :data="data[indextr].supplier_product_code">
                    {{ data[indextr].supplier_product_code }}
                  </vs-td>
                  <vs-td :data="data[indextr].supplier_product_name">
                    {{ data[indextr].supplier_product_name }}
                  </vs-td>
                  <vs-td :data="data[indextr].manufacturing_site">
                    <span v-for="(site, index_of_sites) in data[indextr].manufacturing_site">
                      {{site.site_name}} <br>
                    </span>
                  </vs-td>
                  <vs-td :data="data[indextr].country_processing">
                    <span v-for="country in data[indextr].country_processing">
                      {{ country.name }},
                    </span>
                  </vs-td>
                  <vs-td :data="data[indextr].is_approved">
                    <vs-chip transparent :color="statusColorFactory(data[indextr].status ? data[indextr].status.id : '')">
                      {{data[indextr].status ? data[indextr].status.name : ''}}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="Replicate Raw Material" position="left"  v-can="'create-raw-material'">
                        <vs-button class="ml-2"
                                   @click.stop="onClickReplicateRawMaterial(data[indextr].id, data[indextr].supplier_product_name)"
                                   size="small" color="dark" type="border" icon-pack="feather" icon="icon-copy"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="View" position="left"  v-can:any="['edit-raw-material', 'view-raw-material']">
                        <vs-button class="ml-2"
                                   @click.stop="onClickViewManufacturing(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-can="'view-site'"
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5"></vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
    <create-raw-material-pop-up ref="createRawMaterialPopUp"/>
    <create-raw-material-from-existing-pop-up ref="createRawMaterialFromExistingPopUp"/>
    <replicate-raw-material-pop-up ref="replicateRawMaterialPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import {defaultPagination, perPageList} from "@/constants/config";

  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial');

  import CreateRawMaterialPopUp from '@/components/popups/raw-materials/CreateRawMaterialPopUp'
  import CreateRawMaterialFromExistingPopUp from '@/components/popups/raw-materials/CreateRawMaterialFromExistingPopUp'
  import ReplicateRawMaterialPopUp from '@/components/popups/raw-materials/ReplicateRawMaterialPopUp'

  export default {
    name: 'AllUsersList',
    data() {
      return {
        raw_material_list: [],
        filters: {},
        page: 1,
        meta: {},
        sort: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      CreateRawMaterialPopUp,
      CreateRawMaterialFromExistingPopUp,
      ReplicateRawMaterialPopUp
    },
    mixins: [Filter],
    async mounted() {

    },
    methods: {
      async refreshData () {
        this.fetchRmList()
      },

      async fetchRmList() {
         this.$vs.loading()
        try {
          const {data} = await SupplierRawMaterialRepository.getRawMaterials(this.page, this.filterQuery, this.perPage, this.sort)
          this.raw_material_list =  data.data
          this.meta = data.meta
        } catch (e) {

        }
         this.$vs.loading.close()
      },

      statusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning'
          case 2:
            return 'danger'
          case 3:
            return 'success'
          default:
            return 'danger'
        }
      },
      onClickViewManufacturing(id) {
        if(this.$canAny(['edit-raw-material', 'view-raw-material'])) {
          this.$router.push({path: `/pages/raw-materials/${id}`})
        }
      },
      onClickChooseExistingRawMaterialConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Create raw material',
          text: 'Are you sure you want to create raw material from existing raw material?',
          accept: this.onClickChooseExistingRawMaterial,
          parameters: [id]
        })
      },
      async onClickChooseExistingRawMaterial(id, supplier_product_code) {
        await this.$refs.createRawMaterialFromExistingPopUp.openPopup(id, supplier_product_code)
      },
      async onClickReplicateRawMaterial(id, supplier_product_name) {
        await this.$refs.replicateRawMaterialPopUp.openPopup(id, supplier_product_name)
      },

      async onClickCreateRm() {
        await this.$refs.createRawMaterialPopUp.openPopup()
      },

      filterQueryUpdate() {
        this.fetchRmList()
      },

      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },

      handleSort(key, active) {
        if (key) {
          active = (active === 'desc') ? "-" : '';
          this.sort = active + key;
          this.fetchRmList()
        }

      }

    },
    watch: {
      page(){
        this.fetchRmList()
      },
      perPage() {
        this.fetchRmList()
      },
    }
  }
</script>


<style scoped>
  .user-edit-popup >>> .vs-popup {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
